import { createStore, createEvent } from "effector";
import { ReactNode } from "react";

// Типы вкладок и сценариев
export type DrawerTab = "cart" | "favorites";
export type DrawerType = "main" | "menu" | "profile" | "giftbox-item-selector" | "custom";

// Открыть Drawer с определённой вкладкой и типом
export const openDrawer = createEvent<{ type: DrawerType; tab?: DrawerTab; title?: ReactNode; content?: ReactNode }>();
export const closeDrawer = createEvent();

// Стор состояния Drawer
export const $drawer = createStore<{
  open: boolean;
  type: DrawerType | null;
  tab: DrawerTab | null;
  title?: ReactNode;
  content: ReactNode | null;
}>({
  open: false,
  type: null,
  tab: null,
  title: undefined,
  content: null,
})
  .on(openDrawer, (state, payload) => ({
    open: true,
    type: payload.type,
    tab: payload.tab ?? null,
    title: payload.title,
    content: payload.content ?? null,
  }))
  .on(closeDrawer, () => ({
    open: false,
    type: null,
    tab: null,
    title: undefined,
    content: null,
  }));

// Селекторы
export const $isDrawerOpen = $drawer.map((s) => s.open);
export const $drawerTab = $drawer.map((s) => s.tab);
export const $drawerType = $drawer.map((s) => s.type);
export const $drawerTitle = $drawer.map((s) => s.title, { skipVoid: false });
export const $drawerContent = $drawer.map((s) => s.content);